module.exports = __webpack_public_path__ + "img/zip-lines-3.f1c176c5.jpg";